
let React              = require("react");
let ExternalLinkButton = require("./generic/ExternalLinkButton.jsx");

class DetailsPackageButton extends React.Component {

    constructor() {
        super();   
    }

    render() {    
        return <ExternalLinkButton
                    {...this.props}
                    text="Details"
                    link={this.props.link}/>
    }

}

module.exports = DetailsPackageButton;